export default __webpack_public_path__ + "static/media/hbo.ff101004.svg";